import { KText } from '@/ui-library/components';
import { Flex, Icon } from '@chakra-ui/react';
import { No, StrongNo, StrongYes, Yes } from '@/assets/icons/scorecard';
import { DescriptionField } from './Description';

const options = [
  { id: 'strongYes', label: 'Strong yes', icon: StrongYes },
  { id: 'yes', label: 'Yes', icon: Yes },
  { id: 'no', label: 'No', icon: No },
  {
    id: 'strongNo',
    label: 'Strong no',
    icon: StrongNo,
  },
];

export const OverallEvaluation = () => {
  return (
    <Flex
      border="1px solid"
      borderColor="border-color"
      p="20px"
      borderRadius="sm"
      flexDir="column"
      gap="10px"
      my="16px"
      data-test-id="section-overall-evaluation"
    >
      <KText color="secondary-900" size="sm-medium">
        Overall evaluation
      </KText>
      <DescriptionField name="rating_description" />
      {options?.map((item) => (
        <Flex
          key={item?.id}
          alignItems="center"
          gap="12px"
          data-test-id={`option-rating-${item?.id}`}
        >
          <Icon className="primary-900" as={item?.icon} w="18px" h="18px" />
          <KText>{item?.label}</KText>
        </Flex>
      ))}
    </Flex>
  );
};
